import React, { useContext } from "react";
import { useDispatch } from "react-redux";

import LoadItem from "./LoadItem";
import { showModal } from "../../../../../../store/slices/modal";
import { ManageLoadPostContext } from "../../..";
import { capitalizeFirstLetter } from "../../../../../../utils/helperFunc";

const Loader = () => {
  const dispatch = useDispatch();

  const [loadPostState, loadPostContextDispatch] = useContext(
    ManageLoadPostContext
  );
  const loadType = loadPostState.loadPostInfo?.load_type;

  const openLoadManageModal = () => {
    if (loadType === "vehicle") {
      dispatch(
        showModal({
          modalName: "VehicleLoadManageModal",
          modalData: {
            isForUpdate: false,
            item: null,
            loadPostContextDispatch,
          },
        })
      );
    } else if (loadType === "pallet") {
      dispatch(
        showModal({
          modalName: "PalletLoadManageModal",
          modalData: {
            isForUpdate: false,
            item: null,
            loadPostContextDispatch,
          },
        })
      );
    } else if (loadType === "barrel") {
      dispatch(
        showModal({
          modalName: "BarrelLoadManageModal",
          modalData: {
            isForUpdate: false,
            item: null,
            loadPostContextDispatch,
          },
        })
      );
    } else if (loadType === "stones") {
      dispatch(
        showModal({
          modalName: "StonesLoadManageModal",
          modalData: {
            isForUpdate: false,
            item: null,
            loadPostContextDispatch,
          },
        })
      );
    } else if (loadType === "sand") {
      dispatch(
        showModal({
          modalName: "SandLoadManageModal",
          modalData: {
            isForUpdate: false,
            item: null,
            loadPostContextDispatch,
          },
        })
      );
    } else if (loadType === "laterite") {
      dispatch(
        showModal({
          modalName: "LateriteLoadManageModal",
          modalData: {
            isForUpdate: false,
            item: null,
            loadPostContextDispatch,
          },
        })
      );
    }
  };

  return (
    <>
      <LoadItem />
      <section id="adding-loader">
        <div className="container theme-section">
          <p>
            You can add multilple <b>{capitalizeFirstLetter(loadType)}</b>{" "}
            loader. To add more load type click the <b>“Add”</b> button. To
            collapse all sections click collapse
          </p>

          <div className="multiple-btn">
            <button onClick={openLoadManageModal}>
              Add {capitalizeFirstLetter(loadType)} load
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default React.memo(Loader);
